export const css = {
    root: '_19-323ft',
    active: '_3XeeogY_',
    ' _key': 'certwise-theme/dojo/menu-item'
};
export default css;
